import seedrandom from 'seedrandom';
import adjectives from './adjectives.json';
import animals from './animals.json';

const toTitleCase = (str) =>
  str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );

export const createNameGenerator = ({ seed = null }) => {
  const random = seedrandom(seed);
  const pickRandom = (arr) =>
    arr[Math.floor(random() * 100 * arr.length) % arr.length];

  return () => {
    const animal = pickRandom(animals);

    // limit the adjectives to those that start with the first letter of the animal
    const limitedAdjectives = adjectives.filter(
      (n) => n[0].toLowerCase() === animal[0].toLowerCase()
    );

    // if there are none then open it back up
    const adjectiveSet = limitedAdjectives.length
      ? limitedAdjectives
      : adjectives;

    const adjective = pickRandom(adjectiveSet);

    return {
      firstName: toTitleCase(adjective),
      lastName: toTitleCase(animal),
      fullName: toTitleCase(`${adjective} ${animal}`),
    };
  };
};
